module.exports = __webpack_public_path__ + "static/media/rodriguez-gabriel.9746c73b.jpg";